/*
 * @Date: 2022-08-22 21:34:07
 * @LastEditors: kinfai
 * @Description: 阿里图标
 * @LastEditTime: 2022-08-29 15:46:06
 * @FilePath: \my-app\src\components\AliIcon\index.jsx
 */
import {createFromIconfontCN} from "@ant-design/icons";

function AliIcon(props) {
    const IconFont = createFromIconfontCN({
        scriptUrl: [
            // "./static/font_3604830_ahs37o987ub.js"
            "//at.alicdn.com/t/c/font_3604830_ahs37o987ub.js"
        ],
    });

    return (
        <IconFont
            type={props.type}
            className={("s-icon-font", [props.type])}
            style={{fontSize: props.size, color: props.color, ...props.style}}
            onClick={props.onClick}
        ></IconFont>
    );
}

AliIcon.defaultProps = {
    type: "icon-needkelogocaisetubiao",
    size: "50px",
    color: "",
    style: {},
    onClick: () => {
    }
};

export default AliIcon;
